import { render, staticRenderFns } from "./MyStudents.vue?vue&type=template&id=700a36bd&scoped=true"
import script from "./MyStudents.vue?vue&type=script&lang=js"
export * from "./MyStudents.vue?vue&type=script&lang=js"
import style0 from "./MyStudents.vue?vue&type=style&index=0&id=700a36bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a36bd",
  null
  
)

export default component.exports